export function getResourcePath(path: string) {
	return path && (path.length > 1 || path[0] !== '\\') ? path : '';
}
